import React from 'react'

import Layout from '../Layout'

const Imprint = props => {
    return (
        <div className="general-container">
            <Layout>
                <div className="container">
                    <div className="layout-wrapper">
                        <aside>
                            <h3>Operator of this website</h3>
                            <ul>
                                <li>xymatic GmbH</li>
                                <li>Reichenberger Str. 124</li>
                                <li>10999 Berlin</li>
                                <li>Germany</li>
                            </ul>
                            <h3>Represented by the Managing Directors</h3>
                            <ul>
                                <li>Dr. Andreas Wilhelm</li>
                                <li>Frederik Maucksch</li>
                            </ul>
                            <h3>Registered office</h3>
                            <ul>
                                <li>Berlin, Germany</li>
                            </ul>
                            <h3>Commercial register</h3>
                            <ul>
                                <li>Amtsgericht Charlottenburg, </li>
                                <li>No. HRB 137933 B</li>
                            </ul>
                            <h3>VAT identification number</h3>
                            <ul>
                                <li>DE279928015</li>
                            </ul>
                            <h3>Contact</h3>
                            <ul>
                                <li>+49 30 69814206</li>
                                <li>connect@delight-vr.com</li>
                            </ul>
                        </aside>
                        <main>
                            <h3>Content</h3>
                            <p>
                                The authors of the website delight-vr.com reserves the right not to be responsible for the topicality, correctness, completeness or quality of the information provided. Liability claims regarding damage caused by the use of any information provided, including any kind of information which is incomplete or incorrect,will therefore be rejected.
                                <br />
                                All offers are not-binding and without obligation. Parts of the pages or the complete publication including all offers and information might be extended, changed or partly or completely deleted by the author without separate announcement.
                            </p>
                            <h3>Referrals and links</h3>
                            <p>
                                The author is not responsible for any contents linked or referred to from his pages. If any damage occurs by the use of information presented there, only the author of the respective pages might be liable. Furthermore the author is not liable for any postings or messages published by users of discussion boards, guestbooks or mailinglists provided on his page.
                            </p>
                            <h3>Copyright</h3>
                            <p>
                                The author intended not to use any copyrighted material for the publication or, if not possible, to indicate the copyright of the respective object.
                                The copyright for any material created by the author is reserved. Any duplication or use of objects such as images, diagrams, sounds or texts in other electronic or printed publications is not permitted without the author’s agreement.
                            </p>
                            <h3>Legal validity of this disclaimer</h3>
                            <p>This disclaimer is to be regarded as part of the internet publication which you were referred from. If sections or individual terms of this statement are not legal or correct, the content or validity of the other parts shall remain uninfluenced by this fact.</p>
                        </main>
                    </div>
                </div>
            </Layout>
        </div>
    )
}

export default Imprint


// WEBPACK FOOTER //
// ./src/components/imprint/index.jsx